import { Component, OnInit } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-change-language',
  templateUrl: './change-language.component.html',
  styleUrls: ['./change-language.component.scss']
})
export class ChangeLanguageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    
  }

  toggleChangeLanguage(){
    $("#changeLanguageModal").modal('show');
  }

  toggleMenu() {
    $(".wrapper").removeClass('open-right-sidebar open-setting-panel').toggleClass('slide-nav-toggle');
  }

  toggleRightSidebar() {
    $(".wrapper").toggleClass('open-right-sidebar').removeClass('open-setting-panel');
  }

  toggleMobileNav() {
    $(".wrapper").toggleClass('mobile-nav-open').removeClass('open-right-sidebar');
  }

}
